import { createRoot } from 'react-dom/client';
import Root from './root';

// import './i18n/I18n'; // keep before root container

// replace console.* for disable log on production
if (process.env.REACT_APP_IS_PRODUCTION === 'true') {
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
}

const app = document.getElementById('app');
const root = createRoot(app);

root.render(<Root />);
